import axios from "axios";

import { PaymentSessionToken } from "redmond";
import { purchaseApi, QuoteResponse } from "@b2bportal/purchase-api";

export const pollPriceQuoteV1 = ({
  req,
}: {
  req: PaymentSessionToken;
}): Promise<QuoteResponse> =>
  new Promise((resolve, reject) => {
    try {
      const res = purchaseApi(axios).apiV1PurchaseQuotePollPut({
        value: req.value,
      });

      res.then((body) => resolve(body.data)).catch((e) => reject(e));
    } catch (e) {
      reject(e);
    }
  });
